// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from profile-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ProfileFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 9c4.36 0 8 2.6 8 6a1 1 0 0 1-.883.993L15 16H1a1 1 0 0 1-1-1c0-3.4 3.64-6 8-6Zm0-9a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
      />
    </svg>
  );
}
